import { createApp } from 'vue'
import AntDesign from "ant-design-vue";
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import router, { getBase } from './router'
import VConsole from 'vconsole';
import isMobilePhone, { getBasePath, IsNissan, loadFont } from './utils';
const app = createApp(App)
app.use(router)
app.use(AntDesign)
app.mount('#app')
if(GLOBAL_VARS.BASE_ENV!='prod'&&isMobilePhone()){
  new VConsole();
}
(function (win, doc, src, customVar) {
  var analyticsScript = doc.createElement('script');
  var docScript = doc.getElementsByTagName('script')[0];

  win['dndcAnalyticsVar'] = customVar;
  win[customVar] = win[customVar] || function () {
    (win[customVar].initQueue = win[customVar].initQueue || []).push(arguments);
  };
  analyticsScript.async = 1;
  analyticsScript.src = src;
  docScript.parentNode.insertBefore(analyticsScript, docScript);
})(window, document, 'https://'+GLOBAL_VARS.dongfengApi.gtm+'/js/lib/gtm/2.4.0/gtm-analytics.js', 'dndcAnalytics');
dndcAnalytics('create', {
  trackALIENV: GLOBAL_VARS.BASE_ENV == 'prod' ? 'business' : 'test', // dev-测试环境，prod-生产环境
  siteCode: 've_web', //咨询数据组
  eventCodeURL: 'https://nissan-page.oss-cn-shenzhen.aliyuncs.com/nissan-page/event-code/dn_web-web.json', // page平台生成
  openid: '',
  unionid: '',
  sensorsdata: {
    server_url: GLOBAL_VARS.dongfengApi.serverUrl
  }
});
dndcAnalytics("send", "pageview");
if(IsNissan()){
  import('./assets/nissan-theme-vx6.scss')
}
loadFont('NissanBrandRegular',`${getBasePath()}static/common/fonts/NissanBrandRegular.woff2`)
loadFont('VenuciaRegular',`${getBasePath()}static/common/fonts/MHeiPRC-Medium.otf`);
loadFont('VenuciaLight',`${getBasePath()}static/common/fonts/MHeiPRC-Light.otf`)
//动态设置图标
var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
link.type = "image/x-icon";
link.rel = "shortcut icon";
link.href = IsNissan()?`${GLOBAL_VARS.online3D}nissan.ico`:'https://www.venucia.com/v2resource/website/desktop/assets/images/global/Venucia.ico';  //icon图标
document.getElementsByTagName("head")[0].appendChild(link);
